import {
	FeatureServiceBinder,
	FeatureServiceProviderDefinition,
	SharedFeatureService,
} from '@feature-hub/core';
import { CmsServiceV14 } from '@volkswagen-onehub/cms-service';
import {
	LayerManagerV24,
	ShimBackgroundTypeV2,
} from '@volkswagen-onehub/layer-manager';
import { NavigationServiceV1 } from '@volkswagen-onehub/navigation-service';
import { ServiceConfigProviderV1 } from '@volkswagen-onehub/service-config-provider';
import { UserInteractionServiceV22 } from '@volkswagen-onehub/user-interaction-service';
import axios, { AxiosResponse } from 'axios';
import React from 'react';
import { SfClosedMessage } from './sf-closed-message';
import {
	ensureSfEmbeddedMessagingInitialized,
	launchSfEmbeddedChat,
	SfEmbeddedServiceConfig,
} from './sf-embedded-loader';
import { OneFormSfEmbeddedFeatureServiceV1 } from './v1';

export * from './v1';

export interface SharedStarterFeatureService extends SharedFeatureService {
	readonly '1.0.0': FeatureServiceBinder<OneFormSfEmbeddedFeatureServiceV1>;
}

//Refactorizar función con getHorariosChatSalesforce en VWData
const getHorariosSfEmbedded = async (esData: any): Promise<any> => {
	try {
		const response: AxiosResponse<{ horarios: any }> = await axios.get(
			`${esData.urlOrigin}${esData.urlPath}/${esData.customConfig.brand}/getHorariosSalesforceEmbedded`,
		);

		return response.data.horarios;
	} catch (error) {
		return null;
	}
};

export const oneformSfEmbeddedFeatureServiceDefinition: FeatureServiceProviderDefinition<SharedStarterFeatureService> =
	{
		id: 'es:oneform-sf-embedded-feature-service',

		dependencies: {
			featureServices: {
				'user-interaction-service': '^2.2.0',
				'service-config-provider': '^1.0.0',
				'layer-manager': '^2.5.0',
				'navigation-service': '^1.0.0',
				'cms-service': '^1.3.0',
			},
		},

		create: ({ featureServices }) => {
			const userInteractionService = featureServices[
				'user-interaction-service'
			] as UserInteractionServiceV22;
			const serviceConfigProvider = featureServices[
				'service-config-provider'
			] as ServiceConfigProviderV1;
			const layerManager = featureServices[
				'layer-manager'
			] as LayerManagerV24;
			const navigationService = featureServices[
				'navigation-service'
			] as NavigationServiceV1;
			const cmsService = featureServices['cms-service'] as CmsServiceV14;

			const esSfEmbedded = serviceConfigProvider.configs[
				'es-sf-embedded'
			] as SfEmbeddedServiceConfig;

			const esData = serviceConfigProvider.configs['es-vwdata'] as any;

			// Inicializamos Embedded Service si no está en modo CMS Editor y hay configuración en esSfEmbedded
			if (!cmsService.inEditor && esSfEmbedded) {
				// Consola Omnicanalidad: registrar la acción solo cuando la init haya completado
				ensureSfEmbeddedMessagingInitialized(esSfEmbedded)
					.then(() => {
						userInteractionService.register(
							'es-oneform--sf-embeded-launch',
							{
								action: async () => {
									// Consultamos horarios de Call Me en VW Data
									const horarios =
										await getHorariosSfEmbedded(esData);

									let open = true;
									let closedHeader = '';
									let closedMsg = '';
									if (horarios.closed) {
										closedHeader =
											esSfEmbedded.customConfig
												.closedHeader;
										closedMsg =
											esSfEmbedded.customConfig.closedMsg;
										open = false;
									}

									if (open && horarios) {
										const operatingHoursConfig =
											esSfEmbedded.customConfig
												.operatingHours;

										if (!horarios.isOpenNow) {
											open = false;
											closedHeader =
												operatingHoursConfig.closedHeader;
											closedMsg =
												operatingHoursConfig.closedMsg;
										}
									}

									if (open) {
										try {
											launchSfEmbeddedChat();
										} catch (err) {
											console.error(
												'Error al lanzar el chat:',
												err,
											);
										}
									} else {
										const closedLayer =
											layerManager.openContentLayerV2(
												() =>
													React.createElement(
														SfClosedMessage,
														{
															closedHeader:
																closedHeader,
															closedMsg:
																closedMsg,
															navigationService:
																navigationService,
														},
													),
												{},
												{
													shimBackgroundType:
														ShimBackgroundTypeV2.OPAQUE,
													closeButtonLabel: '',
													contentHeadline: 'Chat',
												},
											);
									}
								},
							},
						);
					})
					.catch(err => {
						console.error(
							'No se pudo inicializar Embedded Messaging (inicio):',
							err,
						);
					});
			}

			return {
				'1.0.0': () => ({
					featureService: {
						helloWorld: () => 'Hello world',
					},
				}),
			};
		},
	};
